export const fetchProgressData = async (): Promise<ProgressData> => {
  try {
    const response = await fetch('/api/progress');
    const data: ProgressData = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
